<template>
    <div class="container">
        <p>
            Copyright © 2020 DataFountain. All Right Reserved 清研兰亭<br />版权所有 | 京ICP备2024092277号-3
            京公网安备11010802025622
        </p>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.container {
    height: 124px;
    padding-top: 20px;
    // padding-bottom: 30px;
    // border: 1px solid #000;
    p {
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #585e66;
        line-height: 36px;
        text-align: center;
        margin: 0;
        padding: 0;
        transform: scale(0.834);
    }
}
</style>
